import React, { useContext } from 'react';
import { connect } from 'react-redux';
import clsx from 'clsx';
import { CompareTable as Table } from '@americanexpress/aqx-components';

import {
  makeGetSelectedCards,
  getSelectedCardsHighlights,
  getAttributeContent,
  getCardAttributeContent,
  getAttributeTableData
} from '../../redux.js';

import { useBreakpoint } from '@americanexpress/aqx-components';
import { Sanitizer } from 'acq-components/lib/base-components/Sanitizer/Sanitizer';
// DE628608: we are to hide toggle switch for now.
// import ToggleSwitch from 'src/universal/components/ToggleSwitch';
import LazyScrollMetricTracker from 'src/universal/components/DTM/LazyScrollMetricTracker';

import styles from '../../__styles__/sharedComparisonTable.scss?modules';
import customStyles from '../../__styles__/attributesTable.scss?modules';
import '../../__styles__/addToolTipGlobal.scss';

import { CurrentPermutationContext } from '../../index.js';

const noCardSelected = (cardList = []) => {
  if (!Array.isArray(cardList) || cardList.length === 0) {
    return true;
  }
  const validCard = cardList.find(shortName => {
    return typeof shortName === 'string' && shortName.length > 0;
  });
  if (!validCard) return true;
  return false;
};

const AttributesTable = ({
  cards,
  cardAttributes,
  attributeContent,
  cardContent,
  tableData
}) => {
  if (noCardSelected(cards)) {
    return null;
  }
  // DE628608: we are to hide toggle switch for now.
  // const [showOnlyDifferentHighlights, setShowOnlyDifferentHighlights] = useState(
  //   false
  // );
  const { sm } = useBreakpoint();
  const { currentPermutations } = useContext(CurrentPermutationContext);

  const visibleCards = sm
    ? [cards[currentPermutations[0] - 1], cards[currentPermutations[1] - 1]]
    : cards;

  const visibleCardContent = sm
    ? [
        cardContent[currentPermutations[0] - 1],
        cardContent[currentPermutations[1] - 1]
      ]
    : cardContent;

  return (
    <div className={clsx(styles.container, customStyles.outer)}>
      {/* <ToggleSwitch
        label="Show Differences"
        qeId="GcsCompareToggle"
        onChange={evt => {
          setShowOnlyDifferentHighlights(evt?.target?.checked);
        }}
      /> */}
      <LazyScrollMetricTracker scrollDtm={tableData.highlightsDtm} />
      <Table
        qeId={'gcsCompareHighlights'}
        // showOnlyDifferentAttributes={showOnlyDifferentHighlights}
        cards={visibleCards}
        cardAttributes={cardAttributes}
        attributeContent={attributeContent}
        cardContent={visibleCardContent}
        tableName={
          <Sanitizer Component="h2" safelySetInnerHTML={tableData.header} />
        }
        styles={customStyles}
      />
      <div className={customStyles.disclaimer}>{tableData.disclaimer}</div>
    </div>
  );
};

const mapStateToProps = () => {
  const getSelectedCards = makeGetSelectedCards();

  return state => ({
    cards: getSelectedCards(state),
    cardAttributes: getSelectedCardsHighlights(state),
    attributeContent: getAttributeContent(state),
    cardContent: getCardAttributeContent(state),
    tableData: getAttributeTableData(state)
  });
};

export default connect(mapStateToProps)(AttributesTable);
